var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.items,"type":"text","label":_vm.label,"placeholder":"Select a country","value":_vm.value,"id":"home-country-select"},on:{"change":function($event){return _vm.updateValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }